// @ts-nocheck
import React, { createRef } from "react";
import RoutingComponent from "../../../../base/common/RoutingComponent";
import styles from "../index.module.scss";
import PageHeader from "../../../commonComponents/pageHeaders/PageHeader";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import ApproveProcedureInformation from "../../../sections/procedureInfoSections/approveProcedureInfoSection";
import TaskInformation from "../../../sections/taskInfoSections";
import ReadOnlyProcedureFileSection from "../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import ReadOnlySupportingFileSection from "../../../sections/supportingFileSections/readOnlySupportingFileSection";
import ActiveShareTaskReadOnly from "../../../sections/sharedTaskSections/activeShareTaskReadOnly";
import CompleteStepBusinessType from "../../../../service/stepBase/completeStepBusinessType";
import StepService from "../../../../service/stepBase/StepService";

const procedureFileRef = createRef();
const supportingFileRef = createRef();
const procedureInfoRef = createRef();
export default class ApprovePPOCompleted extends RoutingComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      procedureInfoState: {},
      modalState: {
        isReturnModalOpen: false,
        isRejectModalOpen: false,
        isModalOpen: false,
        modalOkText: "",
        modalCancelText: "",
        modalChildContent: "",
        handleModalConfirm: () => {},
        handleModalCancel: () => {},
      },
    };
    // @ts-ignore
    this.procedureTaskId = this.props.procedureTaskId;
    // @ts-ignore
    this.procedureID = this.props.procedureID;
    // @ts-ignore
    this.procedureStepID = this.props.procedureStepID;
  }

  render() {
    const {
      isApprovedCompletedPage,
      isSubmittedCompletedPage,
      isReturnedCompletedPage,
      isRejectedCompletedPage,
      procedureInformationData,
      supportingTableData,
      jbProcedureSavedIn,
      taskInformationData,
    } = this.props;
    const { procedureTableData, clientServerPath, savedInRadioValue } =
      this.props.procedureFileData;
    const { receiveDate, requestByName } = procedureInformationData.pageHeadState;
    const { rejectReason } = procedureInformationData;
    const { modalState } = this.state;
    const procedureData = {
      ...this.props.procedureInformationData.procedureInfoState,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
    };
    const params = {
      // @ts-ignore
      TaskId: this.procedureTaskId,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
    };

    return (
      <div className={styles.body}>
        <div className={styles.header}>
          <PageHeader
            title={
              isApprovedCompletedPage || isReturnedCompletedPage || isRejectedCompletedPage
                ? "Approve Primary Procedure Owner"
                : "Change Primary Procedure Owner"
            }
            receiveDate={receiveDate}
            requestBy={requestByName}
            status="Complete"
          />
        </div>
        <ProcedureBlock
          className={styles.approveProcedureBlock}
          child={<TaskInformation data={taskInformationData} />}
          isShowArrow={true}
          isOpen={false}
          testid="task-info-block-arrow"
          onShowDataLoad={() => {
            return StepService.getStepData(
              params,
              this.props.setTaskInfoData,
              this.setError,
              [CompleteStepBusinessType.taskInfo],
              StepService.getMergePayloadBySettingKey([
                CompleteStepBusinessType.taskInfo.settingKey,
              ])
            );
          }}
        />
        <ProcedureBlock
          child={
            <ReadOnlyProcedureFileSection
              procedureFileData={procedureTableData}
              procedureFileRef={procedureFileRef}
              clientServerPath={clientServerPath}
              savedInRadioValue={savedInRadioValue}
              jbProcedureSavedIn={jbProcedureSavedIn}
            />
          }
          isShowArrow={true}
          isOpen={false}
          testid="procedure-file-block-arrow"
          onShowDataLoad={() => {
            return StepService.getStepData(
              params,
              this.props.setProcedureFileData,
              this.setError,
              [CompleteStepBusinessType.procedureFile],
              StepService.getMergePayloadBySettingKey([
                CompleteStepBusinessType.procedureFile.settingKey,
              ])
            );
          }}
        />
        <ProcedureBlock
          child={
            <ReadOnlySupportingFileSection
              supportingFileRef={supportingFileRef}
              supportingFileData={supportingTableData}
            />
          }
          isShowArrow={true}
          isOpen={false}
          testid="supporting-file-block-arrow"
          onShowDataLoad={() => {
            return StepService.getStepData(
              params,
              this.props.setSupportingFileData,
              this.setError,
              [CompleteStepBusinessType.supportingFile],
              StepService.getMergePayloadBySettingKey([
                CompleteStepBusinessType.supportingFile.settingKey,
              ])
            );
          }}
        />
        <ProcedureBlock
          className={styles.ProcedureInfoSection}
          child={
            // @ts-ignore
            <ApproveProcedureInformation
              ref={procedureInfoRef}
              procedureData={procedureData}
              submitData={procedureData}
              noteDisabled={true}
              isPPODisabled={true}
              title="Procedure Information"
              className={styles.approveProcedureInformation}
              closePage={this.props.closePage}
              isShowActionBtns={false}
              isSubmittedCompletedPage={isSubmittedCompletedPage}
              isReturnedCompletedPage={isReturnedCompletedPage}
              modalState={modalState}
            />
          }
          isShowArrow={true}
          isOpen={true}
          testid="procedure-info-block-arrow"
        />
        <ProcedureBlock
          className={styles.approveProcedureBlock}
          child={<ActiveShareTaskReadOnly shareTaskData={this.props.shareTask} />}
          isShowArrow={true}
          testid="share-task-block-arrow"
          onShowDataLoad={() => {
            return StepService.getStepData(
              params,
              this.props.setShareTaskData,
              this.setError,
              [CompleteStepBusinessType.shareTask],
              StepService.getMergePayloadBySettingKey([
                CompleteStepBusinessType.shareTask.settingKey,
              ])
            );
          }}
        />
        {!!rejectReason && (
          <div className={styles.rejectReasonBlock}>
            <span className={styles.rejectReasonTip}>Reject Reason</span>
            <p className={styles.rejectReasonContent}>{rejectReason}</p>
          </div>
        )}
      </div>
    );
  }
}
